export default {
  whatSearch: 'Que cherchez-vous ?',
  products: 'Produits',
  filtersBy: 'Filtrer par',
  delete: 'Supprimer la recherche',
  popularSearch: 'Recherches populaires',
}
